<div class="sidenav-container">
  <div class="main-menu">
    <!-- Default Navigation -->
    @for (item of navigationPages; track item) {
      <ng-container
        *ngTemplateOutlet="pageButtonTml; context: { page: item }"
      ></ng-container>
    }
  </div>

  @if (sidenav.extraMenu) {
    <div class="extras">
      <mat-divider></mat-divider>
      <ng-container *ngTemplateOutlet="sidenav.extraMenu"></ng-container>
    </div>
  }

  <div>
    @if (subscription.isFree && company?.data_type === DataType.FM) {
      <sidenav-fleet-upgrade-banner />
    }

    <div class="smaller-links mat-caption-sm">
      @for (item of externalLinks; track item) {
        @if (item.externalLink) {
          <!-- External Website Link -->
          <a [href]="item.link" target="_blank">
            <ng-container *ngTemplateOutlet="linkDisplay; context: { item }" />
          </a>
        } @else if (item.link) {
          <!-- Internal Link -->
          <a
            [routerLink]="item.link"
            [trackElement]="item.name"
            [trackEvents]="['click', 'mouseenter', 'mouseleave']"
          >
            <ng-container *ngTemplateOutlet="linkDisplay; context: { item }" />
          </a>
        } @else if (item.action) {
          <!-- Dialog -->
          <a
            (click)="onSmallerItemClick(item.action)"
            [trackElement]="item.name"
            [trackEvents]="['click', 'mouseenter', 'mouseleave']"
          >
            <ng-container *ngTemplateOutlet="linkDisplay; context: { item }" />
          </a>
        }
      }
    </div>
  </div>
</div>

<ng-template #pageButtonTml let-page="page">
  @if (
    page.visible !== false &&
    (!page.onlyForInstance || (page.onlyForInstance | includes : subscription.type))
  ) {
    <!-- Direct Link -->
    @if (page.subPages === undefined) {
      @if (
        page.disabled ||
        (page.requirePermissions && !(page.requirePermissions | hasPermissions | async))
      ) {
        <ng-container *ngTemplateOutlet="buttonTml; context: { page, disabled: true }"></ng-container>
      }
      @else {
        <a [routerLink]="page.link" [queryParamsHandling]="getQueryParamsHandling(page)">
          <ng-container *ngTemplateOutlet="buttonTml; context: { page, disabled: false }"></ng-container>
        </a>
      }
    }
    @else {
      <div (click)="toggleSubMenu(page)">
        <ng-container *ngTemplateOutlet="
          buttonTml;
          context: {
            page,
            disabled: page.disabled ||
              (page.requirePermissions && !(page.requirePermissions | hasPermissions | async)) ||
              (page.requireVehicles && !hasVehicles)
          }
        "></ng-container>
      </div>
      <div
        class="sub-menu"
        [ngStyle]="{ 'maxHeight.px': 48 * page.subPages.length }"
        [ngClass]="{ closed: !(activeSubMenus | has : page.name) }"
      >
        @for (subPage of page.subPages; track subPage) {
          @if (
            subPage.disabled ||
            (subPage.requireVehicles && !hasVehicles) ||
            (subPage.requirePermissions && !(subPage.requirePermissions | hasPermissions | async))
          ) {
            <ng-container *ngTemplateOutlet="buttonTml; context: { page: subPage, disabled: true }"></ng-container>
          }
          @else {
            <a
              [routerLink]="subPage.link"
              [queryParamsHandling]="getQueryParamsHandling(subPage)"
            >
              <ng-container *ngTemplateOutlet="buttonTml; context: { page: subPage, disabled: false }"></ng-container>
            </a>
          }
        }
      </div>
    }
  }
</ng-template>

<ng-template #buttonTml let-page="page" let-disabled="disabled">
  @if (
    page.visible !== false &&
    (!page.onlyForInstance || (page.onlyForInstance | includes : subscription.type))
  ) {
    <button
      mat-button
      class="link-button"
      [ngClass]="{
        active:
          (page.subPages === undefined && page | isActive | async) ||
          (page.subPages !== undefined && !(activeSubMenus | has : page.name) && page | isActive | async)
      }"
      [disabled]="disabled"
    >
      @if (page.icon !== undefined) {
        <mat-icon
          class="material-icons-rounded"
          [svgIcon]="page.svgIcon ? page.icon : undefined"
        >
          {{ page.svgIcon ? '' : page.icon }}
        </mat-icon>
      }

      <span class="menu-link-title">
        <span>{{ 'pages.' + page.name | transloco }}</span>
        @if (page.subPages !== undefined) {
          <mat-icon
            class="material-icons-rounded chevron"
            [ngClass]="{ open: activeSubMenus | has : page.name }"
          >
            expand_more
          </mat-icon>
        }
        @else if (disabled) {
          <mat-icon
            class="material-icons-outlined lock"
            [ngClass]="{ open: activeSubMenus | has : page.name }"
          >
            lock
          </mat-icon>
        }
      </span>
    </button>
  }
</ng-template>

<ng-template #linkDisplay let-item="item">
  @if (item.icon) {
    <mat-icon [svgIcon]="item.svgIcon ? item.icon : ''">
      {{ item.icon }}
    </mat-icon>
  }
  <span>
    {{ item.name === 'zevaglobal.com' ? item.name : ('pages.' + item.name | transloco) }}
  </span>
</ng-template>
